export const WELL_CONTROL_ACTION_LABELS: Record<
  string,
  { button: string; listMessage: string; progressive: string; successMessage: string }
> = {
  Scan: {
    button: 'Scan wells',
    listMessage: 'List of wells to be scanned:',
    progressive: 'Scanning wells',
    successMessage: 'scanned',
  },
  'Start Asset': {
    button: 'Start assets',
    listMessage: 'List of assets to be started:',
    progressive: 'Starting assets',
    successMessage: 'started',
  },
  'Shutdown Asset': {
    button: 'Shutdown assets',
    listMessage: 'List of assets to be shutdown:',
    progressive: 'Shutting down assets',
    successMessage: 'shutdown',
  },
  'Clear Alarms': {
    button: 'Clear alarms',
    listMessage: 'List of assets to clear alarms:',
    progressive: 'Clearing alarms',
    successMessage: 'alarms cleared',
  },
  'Reset clocks': {
    button: 'Reset clocks',
    listMessage: 'List of assets to reset clocks:',
    progressive: 'Resetting clocks',
    successMessage: 'clocks reset',
  },
  Default: {
    button: 'Confirm',
    listMessage: 'List of assets to be processed:',
    progressive: 'Processing assets',
    successMessage: 'processed',
  },
};
